import { FORM_FIELD_ID_PREFIX } from "../constants";
import { FormControlType, FormStep, StepsState } from "../model/global"
import { v4 as uuidv4 } from 'uuid';
import { CustomFormFieldState } from "./FormControls/CustomFormField/CustomFormField";


/** Gets a form control by ID from an array of controls for a step */
export const getFormStepField = (fieldname: string, steps: FormControlType[]): FormControlType | undefined => {
	if (!Array.isArray(steps)) return undefined;
	return steps.find(step => step.id === fieldname);
}

/** Extracts a form control from the JSON data by ID and determines its initial state */
export const getFormControlInitialState = (fieldId: string, steps: FormControlType[]): CustomFormFieldState | undefined => {
	if (!Array.isArray(steps)) return undefined;
	const control = steps.find(step => step.id === fieldId);
	if (!control) return undefined;
	const invalid = (control.value === '' || control.value === undefined) && control.required === true
	return {
		name: control.name as string,
		value: control.value,
		originalField: control,
		required: !!control.required,
		valid: !invalid,
		invalidReason: '',
	}
}

/** Return a specific summary field from one of the step summaries */
export const getFormSummaryField = (
	summary: StepsState['formSummary'],
	stepTemplate: FormStep['stepTemplate'],
	controlName: FormControlType['name']
): CustomFormFieldState | undefined => {
	if (!controlName) return undefined;
	const item = summary.steps[stepTemplate][controlName] ? summary.steps[stepTemplate][controlName] : undefined;
	return item;
}

export const getPrefixedFieldId = (id: string | undefined): string => {
	if (!id) return FORM_FIELD_ID_PREFIX + uuidv4();
	const newId = id.replace(' ', '-');
	return `${FORM_FIELD_ID_PREFIX}_${newId}`;
}